import React from 'react';
import { Modal, Spinner, Alert } from 'react-bootstrap';
import QRCode from 'react-qr-code';
import { MobileCredential } from '../../types/mobileCredentials';
import './MobileCredentialsModal.scss';

interface MobileCredentialsModalProps {
  show: boolean;
  onHide: () => void;
  credential: MobileCredential | null;
  loading: boolean;
  error: string | null;
  unitName: string;
}

export const MobileCredentialsModal: React.FC<MobileCredentialsModalProps> = ({
  show,
  onHide,
  credential,
  loading,
  error,
  unitName,
}) => {
  // Format connection string for QR code
  const getConnectionString = (): string => {
    if (!credential) return '';

    const params = new URLSearchParams({
      client_id: credential.client_id,
      client_secret: credential.client_secret,
      account_id: credential.account_id,
      event_id: credential.event_id,
      unit_id: credential.unit_id,
      server: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    });

    return `forcetracker://connect?${params.toString()}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Mobile Credentials - {unitName}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-credentials-modal__body">
        {loading && (
          <div className="mobile-credentials-modal__loading">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-2">Generating credentials...</p>
          </div>
        )}

        {error && (
          <Alert variant="danger">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        {!loading && !error && credential && (
          <div className="mobile-credentials-modal__qr-container">
            <p className="mobile-credentials-modal__instructions">
              Scan this QR code with the ForceTracker mobile app to connect as this unit.
            </p>
            <div className="mobile-credentials-modal__qr-wrapper">
              <QRCode
                value={getConnectionString()}
                size={256}
                level="M"
                className="mobile-credentials-modal__qr-code"
              />
            </div>
            <p className="mobile-credentials-modal__unit-id text-muted mt-3">
              Unit ID: {credential.unit_id}
            </p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
